module.exports = __webpack_public_path__ + "img/security-audit-img-1.3a1dff31.webp";